import { useState } from "react";
import VideoBoxTimer from "../../casinoComponents/videoBox/overlays/VideoBoxTimer";
import QueenCardsOverlay from "../../casinoComponents/videoBox/overlays/QueenCardsOverlay";
import styles from "../../casinoComponents/videoBox/VideoBox.module.css";

/**
 * Queen's .casino-video in the reference markup. The reference puts the title block
 * (.casino-video-title > .casino-name + .casino-video-rid) BEFORE .video-box-container,
 * which the shared VideoBox cannot render, so this page builds its own:
 *   .casino-video > .casino-video-title, .video-box-container > .video-box > iframe,
 *   .casino-video-cards (QueenCardsOverlay), flip-clock timer, rules (i) icon, empty rules holder.
 * The reference has no rules content for queen: its (i) icon opens nothing.
 */
export default function QueenVideo({ title, roundId, iframeSrc, timerValue, cardString, subData }) {
  // Stream error is remembered per source, so a new iframeSrc clears it
  const [streamError, setStreamError] = useState(null); // { src, message }
  const [showCards, setShowCards] = useState(true);
  const iframeError = streamError?.src === iframeSrc;
  const errorMessage = iframeError ? streamError.message : "";
  const handleIframeError = (message = "Video stream unavailable") => setStreamError({ src: iframeSrc, message });
  // new round (first card face-down again) re-opens a hand-closed strip
  if (String(cardString ?? "").split(",")[0].trim() === "1" && !showCards) setShowCards(true);

  return (
    <div className="casino-video">
      <div className="casino-video-title">
        <span className="casino-name">{title}</span>{" "}
        <div className="casino-video-rid">Round ID: {roundId}</div>
      </div>{" "}
      <div className="video-box-container">
        <div className="video-box">
          {iframeError ? (
            <div className={styles.errorMessage}>
              <div>🎥</div>
              <div>{errorMessage}</div>
              <div style={{ fontSize: "0.9rem", marginTop: "0.5rem", opacity: 0.8 }}>
                Please check your connection or try again later
              </div>
            </div>
          ) : (
            <iframe
              src={iframeSrc || undefined}
              title="Live Stream"
              allowFullScreen
              onError={() => handleIframeError()}
              onLoad={(e) => {
                try {
                  const iframeDoc = e.target.contentDocument || e.target.contentWindow?.document;
                  if (iframeDoc?.body?.innerText?.includes("not allowed")) {
                    handleIframeError("Stream access not allowed");
                  }
                } catch {
                  // cross-origin stream: nothing to inspect
                }
              }}
            />
          )}
        </div>
      </div>{" "}
      <QueenCardsOverlay
        normalizedResultData={cardString}
        subData={subData}
        showCards={showCards}
        onToggle={() => setShowCards((s) => !s)}
      />{" "}
      <VideoBoxTimer timerValue={timerValue} />{" "}
      <div className="casino-video-right-icons">
        <div title="Rules" className="casino-video-rules-icon">
          <i className="fas fa-info-circle" />
        </div>
      </div>{" "}
      <div />
    </div>
  );
}
